import { ApiService } from "../../constants";
import { HttpService } from "../../utilities";

interface GetInventoryReward {
  search?: string;
  userin?: string;
  scheduleid?: string;
  page?: number;
  size?: number;
}

export const GetInventoryReward = ({
  search = "",
  page,
  size,
  scheduleid = "",
  userin = "",
}: GetInventoryReward) => {
  return HttpService.get(
    `${
      ApiService.icdc.module.inventoryReward.getList
    }?search=${search}&page=${page}&userin=${userin || ""}`
  );
};

export const postInventoryReward = (data) => {
  return HttpService.post(ApiService.icdc.module.inventoryReward.add, data);
};

export const editInventoryReward = (data) => {
  return HttpService.post(ApiService.icdc.module.inventoryReward.update, data);
};

export const deleteInventoryReward = (data) => {
  return HttpService.post(ApiService.icdc.module.inventoryReward.delete, data);
};

export const saveImage = (data) => {
  return HttpService.post(ApiService.icdc.module.file.uploadImage, data);
};
